import React from 'react';

const PitchBanner = () => {
  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #pitch-banner, #pitch-banner * { visibility: visible !important; }
          #pitch-banner {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 1080px !important;
            height: 450px !important;
            margin: 0 !important;
            border-radius: 0 !important;
            box-shadow: none !important;
          }
          nav, footer { display: none !important; }
          @page { size: 1080px 450px; margin: 0; }
        }
      `}</style>

      <div className="min-h-screen bg-gray-200 pt-24 pb-12 px-4 flex justify-center items-start">
        <div
          id="pitch-banner"
          style={{
            width: '1080px',
            height: '450px',
            background: 'linear-gradient(135deg, #006868 0%, #008B8B 40%, #00A3A3 100%)',
            position: 'relative',
            overflow: 'hidden',
            fontFamily: 'Nunito Sans, Inter, sans-serif',
          }}
        >
          {/* Background shapes */}
          <div style={{
            position: 'absolute', top: '-80px', right: '-60px',
            width: '380px', height: '380px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)',
          }} />
          <div style={{
            position: 'absolute', bottom: '-100px', left: '-40px',
            width: '300px', height: '300px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
          }} />
          <div style={{
            position: 'absolute', top: '60px', right: '200px',
            width: '150px', height: '150px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
          }} />

          {/* Content */}
          <div style={{
            position: 'relative', zIndex: 1,
            height: '100%', display: 'flex', alignItems: 'center',
            padding: '0 72px',
          }}>
            {/* Left side */}
            <div style={{ flex: 1 }}>
              {/* Logo */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '28px' }}>
                <img
                  src="https://customer-assets.emergentagent.com/job_smartedu-ai-4/artifacts/2da2chy6_skolobotlogo.png"
                  alt="Školobot"
                  style={{ height: '44px', filter: 'brightness(0) invert(1)' }}
                />
              </div>

              {/* Headline */}
              <h1 style={{
                color: '#ffffff',
                fontSize: '38px',
                fontWeight: 800,
                lineHeight: 1.15,
                margin: '0 0 16px 0',
                fontFamily: 'Nunito Sans, sans-serif',
                maxWidth: '540px',
              }}>
                AI Platform Built for<br />Czech Schools
              </h1>

              {/* Subheadline */}
              <p style={{
                color: 'rgba(255,255,255,0.8)',
                fontSize: '17px',
                lineHeight: 1.5,
                margin: '0 0 24px 0',
                fontFamily: 'Inter, sans-serif',
                maxWidth: '480px',
              }}>
                Purpose-built AI tools for teachers and school administrators.
                100+ templates, curriculum-aligned content, GDPR compliant.
              </p>

              {/* Tags */}
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {['Vertical AI SaaS for Schools', '308 Paying Customers', '68% Gross Margin', 'CEE → EU Scale-Ready'].map((tag) => (
                  <span key={tag} style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(8px)',
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 600,
                    padding: '6px 14px',
                    borderRadius: '20px',
                    fontFamily: 'Inter, sans-serif',
                    letterSpacing: '0.3px',
                  }}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            {/* Right side — key metrics */}
            <div style={{
              display: 'flex', flexDirection: 'column', gap: '16px',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(12px)',
              borderRadius: '20px',
              padding: '28px 32px',
              border: '1px solid rgba(255,255,255,0.15)',
              minWidth: '260px',
            }}>
              {[
                { value: '100+', label: 'Pedagogical Templates' },
                { value: '50+', label: 'Languages Supported' },
                { value: '§160', label: 'Public Funding Eligible' },
                { value: 'GDPR', label: 'EU Compliant · Data in EU' },
              ].map((m, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
                  <span style={{
                    color: '#F5B700',
                    fontSize: '22px',
                    fontWeight: 800,
                    fontFamily: 'Nunito Sans, sans-serif',
                    minWidth: '60px',
                  }}>
                    {m.value}
                  </span>
                  <span style={{
                    color: 'rgba(255,255,255,0.75)',
                    fontSize: '13px',
                    fontFamily: 'Inter, sans-serif',
                  }}>
                    {m.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom bar */}
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            height: '4px',
            background: 'linear-gradient(90deg, #F5B700 0%, #FFD54F 50%, #F5B700 100%)',
          }} />
        </div>
      </div>
    </>
  );
};

export default PitchBanner;
